import React from 'react';
import { Button, ListGroup, ListGroupItem } from 'reactstrap';

const CategoryManager = ({ categories, onSelectCategory,activeCategory,onEdit, onDelete })=>{
    return(
        <React.Fragment>
            <ListGroup>
                {categories.map(category => (
                    <ListGroupItem 
                        key={category.id} 
                        onClick={() => onSelectCategory(category)}
                        tag="button"
                        action
                        active={activeCategory && activeCategory.id === category.id}
                        className="float-action-list-item"
                    >
                        <div className="float-action-content">
                            <span>{category.category_name}</span>
                            <div className="float-action-buttons">
                                <Button 
                                    size="sm" 
                                    color="warning" 
                                    outline
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        onEdit({
                                            ...category,
                                            name:category?.category_name,
                                            listgroup:'Category'});
                                    }}
                                >
                                    <span className='ri-pencil-fill'></span>
                                </Button>
                                <Button 
                                    size="sm" 
                                    color="danger" 
                                    outline
                                    onClick={(e) => { 
                                        e.stopPropagation();
                                        onDelete({
                                            ...category,
                                            name:category?.category_name,
                                            listgroup:'Category'});
                                    }}
                                >
                                    <span className='ri-delete-bin-line'></span>
                                </Button>
                            </div>
                        </div>
                    </ListGroupItem>
                ))}
            </ListGroup>
        </React.Fragment>
    )
}

export default CategoryManager